var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNomicLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 101.43 101.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#6300ff;}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.87,27A22.53,22.53,0,0,0,51.34,49.56a22.54,22.54,0,0,1-45.07,0,45.07,45.07,0,0,1,90.13,0A22.53,22.53,0,0,0,73.87,27Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,76.59a27.06,27.06,0,0,1-27-27,49.57,49.57,0,0,1,99.13,0h-9a18,18,0,0,0-36.06,0A27.06,27.06,0,0,1,28.8,76.59ZM51.34,9A40.61,40.61,0,0,0,10.77,49.56a18,18,0,0,0,36.07,0,27.06,27.06,0,0,1,27-27,26.78,26.78,0,0,1,9,1.54A40.48,40.48,0,0,0,51.34,9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.34,94.44A45.06,45.06,0,0,1,6.27,49.38a22.54,22.54,0,0,0,45.07,0,22.53,22.53,0,1,1,45.06,0A45.06,45.06,0,0,1,51.34,94.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.34,98.94A49.62,49.62,0,0,1,1.77,49.38h9a18,18,0,0,0,36.07,0,27,27,0,1,1,54.06,0A49.62,49.62,0,0,1,51.34,98.94ZM19.81,74.87A40.55,40.55,0,0,0,91.9,49.38a18,18,0,1,0-36.06,0,27.07,27.07,0,0,1-27,27A26.78,26.78,0,0,1,19.81,74.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNomicLogo);
export default __webpack_public_path__ + "static/media/nomic-logo.725ff88575dcd7e9baef01d991e2d547.svg";
export { ForwardRef as ReactComponent };